import React from "react";

interface BarGroupChartProps {
  data: { month: string; values: number[] }[];
}

export const BarGroupChart = ({ data }: BarGroupChartProps) => {
  return (
    <div className="grid grid-cols-12 gap-2 items-end h-48 border rounded-md px-4 py-4 bg-gray-50">
      {data.map(({ month, values }) => (
        <div
          key={month}
          className="flex flex-col items-center justify-end h-full"
        >
          <div className="flex gap-1 items-end h-full relative">
            {values.map((val, idx) => {
              const bgColor = idx % 2 !== 0 ? "#00B2E3" : "#385CAD";

              return (
                <div
                  key={idx}
                  className="w-5 rounded-sm transition-all flex items-center justify-center"
                  style={{
                    height: `${val || 1}%`,
                    backgroundColor: bgColor,
                  }}
                  title={`${val}%`}
                >
                  <span
                    className={`text-[6px] font-medium ${
                      val < 10 ? "top-1/2 absolute" : ""
                    }`}
                    style={{ color: val < 10 ? bgColor : "#ffffff" }}
                  >
                    {val}%
                  </span>
                </div>
              );
            })}
          </div>
          <span className="text-[8px] font-medium mt-2 text-gray-600">
            {month.slice(0, 3)}
          </span>
        </div>
      ))}
    </div>
  );
};
